import { X, Shield, FileText, Lock, Mail } from 'lucide-react'
const LegalModal = ({ type, onClose }) => {
  if (!type) return null
  const contentMap = {
    legal: {
      title: 'Aviso Legal',
      icon: FileText,
      body: (
        <div className="space-y-4 text-xs sm:text-sm text-[#CBD5E1] leading-relaxed">
          <p>
            En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio,
            de Servicios de la Sociedad de la Información y de Comercio
            Electrónico (LSSI-CE), se informa de los datos identificativos de la
            entidad:
          </p>
          <div className="p-3 bg-[#012622] rounded-lg border border-[#00FF9D]/20 font-mono text-xs">
            <div>
              <strong>Denominación Social:</strong> Hutrit Technologies S.L.
            </div>
            <div>
              <strong>Sede Operativa:</strong> Marina de Empresas, Carrer del
              Moll de la Duana s/n, 46024 Valencia, España
            </div>
            <div>
              <strong>Programa de Aceleración:</strong> Lanzadera Ecosistema
              Juan Roig
            </div>
            <div>
              <strong>Email de Contacto:</strong> legal@hutrit.ai
            </div>
          </div>
          <p>
            Hutrit opera como proveedor de software e infraestructura B2B de
            inteligencia artificial para agencias de marketing y corporaciones.
          </p>
        </div>
      ),
    },
    privacy: {
      title: 'Pol\xEDtica de Privacidad y Protecci\xF3n de Datos',
      icon: Lock,
      body: (
        <div className="space-y-4 text-xs sm:text-sm text-[#CBD5E1] leading-relaxed">
          <p>
            De conformidad con el Reglamento General de Protección de Datos
            (RGPD UE 2016/679) y la Ley Orgánica 3/2018 (LOPDGDD), le
            garantizamos:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Aislamiento estricto de datos:</strong> La información,
              briefings y creatividades de sus clientes son procesados en
              entornos segregados y jamás son utilizados para entrenar modelos
              públicos o de terceros.
            </li>
            <li>
              <strong>Finalidad:</strong> Gestión de su cuenta, orquestación de
              agentes de IA y prestación del servicio contratado.
            </li>
            <li>
              <strong>Derechos ARCO:</strong> Puede ejercer sus derechos de
              acceso, rectificación, supresión y limitación escribiendo a
              privacidad@hutrit.ai.
            </li>
          </ul>
        </div>
      ),
    },
    terms: {
      title: 'T\xE9rminos del Servicio',
      icon: Shield,
      body: (
        <div className="space-y-4 text-xs sm:text-sm text-[#CBD5E1] leading-relaxed">
          <p>Al contratar la suscripción plana de Hutrit (500 €/mes):</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Alcance de servicio:</strong> Cobertura completa para un
              máximo de 10 cuentas de cliente activas de manera simultánea en la
              oficina virtual.
            </li>
            <li>
              <strong>Propiedad Intelectual:</strong> Todos los copies,
              creatividades, análisis e informes generados por los Agentes de IA
              son de exclusiva propiedad de su agencia o de su cliente final.
            </li>
            <li>
              <strong>Sin permanencia:</strong> La suscripción se renueva
              mensualmente y puede ser cancelada en cualquier momento con previo
              aviso antes del siguiente ciclo de facturación.
            </li>
          </ul>
        </div>
      ),
    },
    contact: {
      title: 'Contacto & Oficina Central',
      icon: Mail,
      body: (
        <div className="space-y-4 text-xs sm:text-sm text-[#CBD5E1] leading-relaxed">
          <p>
            ¿Tienes dudas técnicas o necesitas una integración a medida para más
            de 25 clientes?
          </p>
          <div className="p-4 bg-[#012622] rounded-xl border border-[#00FF9D]/30 space-y-3 font-mono text-xs">
            <div className="flex items-center justify-between">
              <span className="text-[#CBD5E1]">Demostraciones & Ventas:</span>
              <span className="text-[#00FF9D] font-bold">demo@hutrit.ai</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-[#CBD5E1]">
                Soporte Técnico de Agentes:
              </span>
              <span className="text-white font-bold">support@hutrit.ai</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-[#CBD5E1]">Ubicación:</span>
              <span className="text-white">Marina de Empresas, Valencia</span>
            </div>
          </div>
          <p className="text-xs text-[#CBD5E1]/80">
            Horario de atención humana: Lunes a Viernes de 9:00 a 18:30 CET. Los
            agentes de IA operan 24 horas al día los 365 días del año.
          </p>
        </div>
      ),
    },
  }
  const activeContent = contentMap[type]
  const Icon = activeContent.icon
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-in fade-in duration-200">
      <div className="bg-[#031E1B] border border-[#00FF9D]/40 rounded-2xl max-w-lg w-full p-6 sm:p-8 shadow-[0_0_50px_rgba(0,255,157,0.25)] relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-lg bg-[#05332E] text-[#CBD5E1] hover:text-white border border-[#00FF9D]/20 cursor-pointer"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-[#05332E] border border-[#00FF9D]/40 flex items-center justify-center text-[#00FF9D]">
            <Icon className="w-5 h-5" />
          </div>
          <h3 className="text-xl font-bold text-white">
            {activeContent.title}
          </h3>
        </div>

        {activeContent.body}

        <div className="mt-6 pt-4 border-t border-[#05332E] flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-full bg-[#00FF9D] text-[#012622] font-bold text-xs hover:bg-[#00E676] cursor-pointer"
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  )
}
export { LegalModal }
